import { request } from "utils/api";
import { serialize } from "object-to-formdata";

// create story params from POST /admin/stories
export interface CreateStoryParams {
    anyOfSportForms?: string[],
    attachedMedia: File[],
    authorClubId?: string,
    bookingIds?: string[],
    clubId?: string,
    commentsAreEnabled?: boolean,
    content: string,
    authorAsCompanyProfile?: boolean,
    clubSite?: string,
}

// create story as admin (POST /admin/stories)
export const postStories = (data: CreateStoryParams) => {
    const formData = serialize(data);
    formData.delete("attachedMedia[]"); // fix weird array stuff
    data.attachedMedia.forEach((f) => formData.append("attachedMedia", f));
    if (data.bookingIds && data.bookingIds.length > 1) {
        formData.delete("bookingIds[]"); // fix weird array stuff
        data.bookingIds.forEach((id) => formData.append("bookingIds", id));
    }
    return request<{}>({
        data: formData,
        endpoint: "/admin/stories",
        method: "post",
    });
};

// delete an existing story as admin (DELETE /admin/stories)
export const deleteStories = (data: {
    storyId: string,
}) => request<{}>({
    data,
    endpoint: "/admin/stories",
    method: "delete",
});

export const postStoriesAudienceSize = (data: {
    clubId?: string,
    anyOfSportForms?: string[],
    bookingIds?: string[],
    clubSite?: string,
}) => request<{ audienceSize: number }>({
    data,
    endpoint: "/admin/stories/audience-size",
    method: "post",
});
